import { useEffect, useState } from 'react';
import css from './ContractRequests.module.css';

// import RollbackButton from '../../_common/elements/RollbackButton';
import ViewCertificateButton from '../../_common/elements/ViewCertificateButton';

import * as requestServices from '../../../../services/requestServices';
import { Link } from 'react-router-dom';

function ContractRequests({ contractId }) {
    const [requests, setRequests] = useState([]);
    console.log(contractId);


    useEffect(() => {
        if (contractId) {
            requestServices
                .getOptionId('getByContractId', contractId)
                .then((res) => {
                    console.log(res);

                    setRequests(res.data);
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    }, [contractId]);

    const varStyles = {
        Open: css.red,
        Enrolled: css.orange,
        Completed: css.green,
        Cancelled: css.black,
    };

    return (
        <div>
            <h2 className={css.h2}>Contract requests</h2>
            <table className={css.table}>
                <thead className={css.thead}>
                    <tr>
                        <th className={css.th}>#</th>
                        <th className={css.th}>Name</th>
                        <th className={css.th}>Program</th>
                        <th className={css.th}>Status</th>
                        <th className={css.th} style={{ textAlign: 'center' }}>
                            Course
                        </th>
                        <th className={css.th} style={{ textAlign: 'center' }}>
                            Results
                        </th>
                        <th className={css.th} style={{ textAlign: 'center' }}>
                            Cert/RB
                        </th>
                        {/* <th className={css.th}></th> */}
                    </tr>
                </thead>
                <tbody className={css.tbody}>
                    {requests.map((x, i) =>
                        requests[0].requestId ? (
                            <tr key={x.requestId} id={x.requestId}>
                                <td>{i + 1}</td>
                                <td
                                
                                >
                                    <Link className={css.link} to={`/student/details/${x.studentNo}`}>
                                    ({x.studentNo}){' '}{x.studentName}
                                    </Link>
                                </td>
                                <td>{x.programTitle} </td>
                                <td className={varStyles[x.requestStatusTitle]}>
                                    <span>{x.requestStatusTitle}</span>
                                </td>
                                <td style={{ textAlign: 'center' }}>
                                    <Link to={`/course/details/${x.courseId}`}>{x.courseNo}</Link>
                                </td>
                                <td style={{ textAlign: 'center', fontSize: '1rem', fontWeight: 600 }}>
                                    <span style={x.isAtt ? { color: 'green' } : { color: 'red' }}>{x.isAtt ? '☑' : '☒'}</span>/
                                    <span style={x.isPass ? { color: 'green' } : { color: 'red' }}>{x.isPass ? '☑' : '☒'}</span>
                                </td>
                                <td style={{ textAlign: 'center' }}>
                                    <ViewCertificateButton certificateLink={x.certificateLink} />
                                </td>
                                {/* <td style={{ textAlign: 'center' }}>
                                    {x.certificateLink ? (
                                        x.certificateLink && <ViewCertificateButton certificateLink={x.certificateLink} />
                                    ) : ['Closed', 'Cancelled'].some((st) => st === x.courseStatusName) ? (
                                        <></>
                                    ) : (
                                        <RollbackButton enrollId={x.enrollId} onConfirm={() => {}} />
                                    )}
                                </td> */}
                                {/* <td style={{ textAlign: 'center' }}>
                                        {(!x.courseTitle || Number(x.courseStatusId) === 3) || x.certificateLink? (
                                            <></>
                                        ) : (
                                            <RollbackButton enrollId={x.enrollId} onConfirm={onConfirmRollback} />
                                        )}
                                    </td> */}
                            </tr>
                        ) : (
                            <tr>
                                <td colSpan={5} style={{ textAlign: 'center' }}>
                                    No matching records found.
                                </td>
                            </tr>
                        )
                    )}
                </tbody>
            </table>
        </div>
    );
}

export default ContractRequests;
